import { $http } from '@/utils';

/**
 * @namespace Service
 * @class SignedAuthenticate
 * @exports Service/Account/SignedAuthenticate
 * @description API SignedAuthenticate Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class SignedAuthenticate {
	/**
	 * @static @name post
	 * @description Perform a signed authentication
	 * @param {Object} payload
	 * @returns {Object} Promise a http response
	 */
	static post(payload) {
		return $http.post(`account/signed-authenticate`, payload);
	}
}
